import { render, staticRenderFns } from "./PayedVariants.vue?vue&type=template&id=1b7d8fb6&scoped=true&"
import script from "./PayedVariants.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PayedVariants.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PayedVariants.vue?vue&type=style&index=0&id=1b7d8fb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7d8fb6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PaymentModals: require('/usr/www/nuxt/components/Payment/PaymentModals.vue').default})
